import Cookies from "js-cookie";
import { Fragment, useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  ChevronDownIcon,
  UserIcon,
  UsersIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import Logo from "../../assets/svg/logo.svg";
import VersionComponent from "../../components/VersionComponent";
import { isEmpty } from 'lodash';
import { Bars3Icon } from "@heroicons/react/24/solid";
import {
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarLeftExpand,
} from "react-icons/tb";
import useSidebarCollapsed from "../../hooks/useSidebarCollapsed";

const TicketIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
      />
    </svg>
  );
};

const initialNavigation = [
  { name: "관리자 관리", href: "/user/admin", icon: UserIcon },
  { name: "회원 관리", href: "/user/user", icon: UsersIcon },
  // { name: "회원권 관리", href: "/user/coupon", icon: TicketIcon },
  { name: '조직도 관리', href: '/user/treeViewDetail', icon: UserIcon },
  // { name: "코드 관리", href: "/code", icon: CodeListIcon },
  // { name: "보고서", href: "/report", icon: ChartPieIcon },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function UserLayout({ children }, ...props) {
  const userNavigation = [
    // { name: "Your profile", href: "#" },
    { name: "로그아웃", id: "logout" },
  ];

  const [sidebarOpen, setSidebarOpen] = useState(false);
  // 데스크톱 사이드바 접기(모바일 드로어인 sidebarOpen 과는 별개)
  const [sidebarCollapsed, setSidebarCollapsed] = useSidebarCollapsed();
  const [navigation, setNavigation] = useState(initialNavigation);
  const { auth, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const dbConfig = localStorage.getItem('X-DB-KEY');
  const isUrinalysis = () => dbConfig && !isEmpty(dbConfig) && dbConfig === 'urinalysis';

  useEffect(() => {
    setNavigation(navigation);
    // if (isUrinalysis()) {
    //   const filteredNavs = navigation.filter((item) => {
    //     if (item.name !== '회원권 관리') {
    //       return item;
    //     }
    //   });
    //   console.log("🚀 ~ filteredNavs ~ 소변 회원 filteredNavs:", filteredNavs);
    //   setNavigation(filteredNavs);
    // } else {
    //   const filteredNavs = navigation.filter((item) => {
    //     if (item.name !== '조직도 관리') {
    //       return item;
    //     }
    //   });
    //   console.log("🚀 ~ filteredNavs ~ 활성 회원 filteredNavs:", filteredNavs);
    //   setNavigation(filteredNavs);
    // }
  }, []);

  const handleLogout = () => {
    console.log("CALLED LOGOUT ==> ");
    Cookies.remove("access-token");

    // localStorage.removeItem("adminInfo");
    // setAuth({});
    logout();
    navigate("/");
  };

  function handleOnClickUserMenuItem(id) {
    console.log("MENU ID => ", id);
    switch (id) {
      case "logout":
        handleLogout();
        break;
      default:
        break;
    }
  }

  return (
    <>
      <div className="flex h-screen flex-col overflow-hidden bg-slate-50">
        <Dialog
          as="div"
          open={sidebarOpen}
          className="relative z-40 lg:hidden"
          onClose={setSidebarOpen}
        >
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
          />

          <div className="fixed inset-0 flex">
            <DialogPanel
              transition
              className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
            >
              <TransitionChild>
                <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                  <button
                    type="button"
                    className="-m-2.5 p-2.5"
                    onClick={() => setSidebarOpen(false)}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XMarkIcon
                      className="h-6 w-6 text-white"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </TransitionChild>
              <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 pb-4 ring-1 ring-white/10">
                <div className="flex h-8 shrink-0 items-center">
                  <Link to={"/user/dashboard"}>
                    <img
                      className="h-8 w-auto"
                      src={Logo}
                      alt="S휴먼헬스케어"
                    />
                  </Link>
                </div>
                <nav className="flex flex-1 flex-col">
                  <ul className="flex flex-1 flex-col gap-y-7">
                    <li>
                      <ul className="-mx-2 space-y-1">
                        {navigation.map((item) => (
                          <li key={item.name}>
                            {item.href !== "" && (
                              <Link
                                to={item.href}
                                className={classNames(
                                  location.pathname === item.href
                                    ? "bg-gray-800 text-white"
                                    : "text-gray-400 hover:text-white hover:bg-gray-800",
                                  "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                                )}
                              >
                                <item.icon
                                  className="h-6 w-6 shrink-0"
                                  aria-hidden="true"
                                />
                                {item.name}
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </div>
        </Dialog>

        {/* Static sidebar for desktop */}
        {/* 플로팅 사이드바 — AdminLayout 과 동일 규격(lg:pr-4 lg:pt-4 + rounded-r-2xl + shadow-float). */}
        <div
          className={classNames(
            "hidden transition-transform duration-300 ease-[cubic-bezier(.4,0,.2,1)] lg:fixed lg:bottom-0 lg:left-0 lg:top-0 lg:z-50 lg:flex lg:w-72 lg:flex-col lg:pr-4 lg:pt-4",
            sidebarCollapsed ? "lg:-translate-x-full" : "lg:translate-x-0"
          )}
        >
          {/* 접기 버튼 — AdminLayout 과 동일하게 fixed 컨테이너 기준 우상단 고정(카드 스크롤과 분리). */}
          <button
            type="button"
            onClick={() => setSidebarCollapsed(true)}
            aria-label="사이드바 접기"
            aria-expanded={true}
            className="motion-press absolute right-7 top-7 z-10 inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-400 hover:bg-gray-800 hover:text-white"
          >
            <TbLayoutSidebarLeftCollapse className="h-5 w-5" aria-hidden="true" />
          </button>
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="shadow-float flex grow flex-col gap-y-5 overflow-y-auto rounded-r-2xl bg-gray-900 px-6 py-6 ring-1 ring-white/10">
            <label className="flex shrink-0 items-center justify-center text-lg font-bold text-gray-100">
              S휴먼헬스케어 {isUrinalysis() ? '소변검사' : '활성산소'}
            </label>
            <div className="flex h-24 mt-6 shrink-0 items-center justify-center">
              <Link to={"/user/dashboard"}>
                <img className="h-32 w-auto" src={Logo} alt="S휴먼헬스케어" />
              </Link>
            </div>
            <nav className="flex flex-1 flex-col mt-5">
              <ul className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul className="-mx-2 space-y-1">
                    {navigation.map((item) => (
                      <li key={item.name}>
                        <Link
                          to={item.href}
                          className={classNames(
                            location.pathname === item.href
                              ? "bg-gray-800 text-white"
                              : "text-gray-400 hover:text-white hover:font-bold hover:text-base hover:bg-gray-800",
                            "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-normal"
                          )}
                        >
                          <item.icon
                            className="h-6 w-6 shrink-0"
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </nav>
            <VersionComponent />
          </div>
        </div>
        {/* 상단바: 배경/보더는 화면 전체 폭. 사이드바가 위를 덮으므로 z 는 그보다 낮게. */}
        <div className="z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
            <button type="button" className="-m-2.5 p-2.5 text-gray-700 lg:hidden" onClick={() => setSidebarOpen(true)}>
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
            
            {/* 접혔을 때만 노출되는 펼치기 버튼 — 사라진 사이드바 자리(좌상단)에 원형으로 남는다 */}
            {sidebarCollapsed && (
              <button
                type="button"
                onClick={() => setSidebarCollapsed(false)}
                aria-label="사이드바 펼치기"
                aria-expanded={false}
                className="motion-press hidden h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-gray-600 shadow-sm ring-1 ring-gray-300 hover:bg-gray-50 lg:inline-flex"
              >
                <TbLayoutSidebarLeftExpand className="h-5 w-5" aria-hidden="true" />
              </button>
            )}

            {/* 펼침: lg:pl-64 = px-8(32px) + 256px → 사이드바 폭(288px) 바로 뒤에서 시작 */}
            <div
              className={classNames(
                "flex flex-1 gap-x-4 self-stretch transition-[padding] duration-300 ease-[cubic-bezier(.4,0,.2,1)] lg:gap-x-6",
                sidebarCollapsed ? "lg:pl-0" : "lg:pl-64"
              )}
            >
              <div className="relative flex flex-1" />
              <div className="flex items-center gap-x-4 lg:gap-x-6  px-3 py-3">
                {/* Profile dropdown */}
                <Menu as="div" className="relative">
                  <MenuButton className="-m-1.5 flex items-center p-1.5 focus:outline-none outline-none border-none">
                    <span className="inline-block h-10 w-10 overflow-hidden rounded-full bg-gray-100 border border-gray-300">
                      <svg
                        className="h-full w-full text-gray-300"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    </span>
                    <span className="hidden lg:flex lg:items-center">
                      <span
                        className="ml-4 text-sm font-semibold leading-6 text-gray-900"
                        aria-hidden="true"
                      >
                        {auth.admin_name}
                      </span>
                      <ChevronDownIcon
                        className="ml-2 h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </span>
                  </MenuButton>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <MenuItems className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                      {userNavigation.map((item) => (
                        <MenuItem key={item.name}>
                          {({ active }) => (
                            <span
                              onClick={() => handleOnClickUserMenuItem(item.id)}
                              className={classNames(
                                active ? "bg-gray-50" : "",
                                "block px-3 py-1 text-sm leading-6 text-gray-900 cursor-pointer"
                              )}
                            >
                              {item.name}
                            </span>
                          )}
                        </MenuItem>
                      ))}
                    </MenuItems>
                  </Transition>
                </Menu>
              </div>
          </div>
        </div>

        {/* 상단바 아래 영역 — 사이드바는 fixed 라 폭을 pl-72 로만 비워둔다(접히면 0). */}
        <div
          className={classNames(
            "flex min-h-0 flex-1 flex-col transition-[padding] duration-300 ease-[cubic-bezier(.4,0,.2,1)]",
            sidebarCollapsed ? "lg:pl-0" : "lg:pl-72"
          )}
        >
          <main className="min-h-0 flex-1 overflow-y-auto lg:pr-4 lg:pt-4">{children}</main>
        </div>
      </div>
    </>
  );
}
